import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FloatingLabelDirective } from './floating-label.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [FloatingLabelDirective],
  exports: [FloatingLabelDirective]
})
export class FloatingLabelModule {}
